import { render, staticRenderFns } from "./desensitizationRules.vue?vue&type=template&id=7474c73b&scoped=true"
import script from "./desensitizationRules.vue?vue&type=script&lang=js"
export * from "./desensitizationRules.vue?vue&type=script&lang=js"
import style0 from "./desensitizationRules.vue?vue&type=style&index=0&id=7474c73b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7474c73b",
  null
  
)

export default component.exports